import QrCodeScannerView from "./QrCodeScannerView";

export default function QrCodeScanner() {
  return <QrCodeScannerView />;
}
